import React, {useState, useEffect} from "react";
import "./coaching.scss";
import {CakeIcon, CalendarIcon} from "../../../../assets/icons/sidebarIcons";
import {useNavigate} from "react-router-dom";
import {formateDate} from "../../../utils/constant";
import DemoImage from "../../../../assets/images/d-image.png";

const ListingComp = ({ Data }) => {
  let navigate = useNavigate();
  const [imageError, setImageError] = useState(false);
  
  // Reset image error when profile image URL changes
  useEffect(() => {
    setImageError(false);
  }, [Data?.profileImage]);
  
  return (
    <div
      className="main_div_listing"
      onClick={() => navigate(`/coaching/client-details/${Data?._id}`)}
    >
      <div className="inner_div_comp">
        <div
          className="header"
          style={{
            borderBottom:
              Data?.isBdShow || Data?.isAniShow ? "1px solid #353535" : "none",
            paddingBottom: Data?.isBdShow || Data?.isAniShow ? "15px" : "0px",
          }}
        >
          <div className="Profile">
            <div className="img_div">
              <img 
                className={imageError ? "img-error" : ""}
                src={imageError || !Data?.profileImage ? DemoImage : Data?.profileImage} 
                onError={(e) => {
                  if (e.target.src !== DemoImage) {
                    setImageError(true);
                  }
                }}
                onLoad={() => {
                  // Reset error state when image loads successfully
                  if (!imageError && Data?.profileImage) {
                    setImageError(false);
                  }
                }}
                alt="Profile"
              />
            </div>
            <div className="name_section">
              <p>{Data?.fullName ? Data?.fullName : "-"}</p>
              <p className="para">{Data?.email ? Data?.email : "-"}</p>
            </div>
          </div>
          
          <div>
            <div className="date_time_main_div">
              {Data?.startDate !== null ? (
                  <div className="inner_div_date">
                    <p className="aplha_date">Start Date</p>
                    <div className="inner_time_div">
                      <p>{Data?.startDate ? formateDate(Data?.startDate ): '-' }</p>
                      {/*<p>{GetTime(Data?.lastSession?.coachingStart)}</p>*/}
                    </div>
                  </div>
              ) : (
                  ""
              )}
              {Data?.endDate !== null ? (
                  <div className="inner_div_date">
                    <p className="aplha_date">End Date</p>
                    <div className="inner_time_div">
                      <p>{Data?.endDate ? formateDate(Data?.endDate): '-' }</p>
                      {/*<p>{GetTime(Data?.lastSession?.coachingStart)}</p>*/}
                    </div>
                  </div>
              ) : (
                  ""
              )}
            </div>
          </div>

         
        </div>
        <div className="event_section">
          <div className={'dates'}>
            {Data?.dob !== null ? (
                <div className="birthday_div">
                  <CakeIcon />
                  <p>Birthday : {Data?.dob ? formateDate(Data?.dob): '-' }</p>
                </div>
            ) : (
                ""
            )}
            {Data?.anniversary !== null ? (
                <div className="birthday_div">
                  <CalendarIcon />
                  <p>Anniversary : { Data?.anniversary ? formateDate(Data?.anniversary) : '-'}</p>
                </div>
            ) : (
                "-"
            )}
          </div>

          <div className={'status-box'}>
            <span className={`status ${Data?.status ? Data.status.toLowerCase() : 'inactive'}`}>
              {Data?.status || 'Unknown'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingComp;
